// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"24":"898272c7","533":"78fd8ae9","621":"898272c7","692":"b2ac7d45","711":"62f3d414"}[chunkId] + ".chunk.css";
};